export const type_projectConstants = {
    GETALL_TYPE_PROJECT_REQUEST: "GETALL_TYPE_PROJECT_REQUEST",
    GETALL_TYPE_PROJECT_SUCCESS: "GETALL_TYPE_PROJECT_SUCCESS",
    GETALL_TYPE_PROJECT_FAILURE: "GETALL_TYPE_PROJECT_FAILURE",
}